import React from 'react'
import PropTypes from 'prop-types'

export default class SceneComponent extends React.Component {
  static propTypes = {
    onRef: PropTypes.any,
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }
}



// WEBPACK FOOTER //
// ./src/views/scenes/SceneComponent.js